import { Box, DialogContent } from '@mui/material';

const VnModalBody = ({ children }: { children: React.ReactNode }) => {
  return (
    <DialogContent>
      <Box sx={{ padding: '8px 16px' }}>{children}</Box>
    </DialogContent>
  );
};

export default VnModalBody;
